import { apiClient } from "./api";
import { isAxiosError } from "axios";

class EstadisticasService {
  private basicURL: string;

  constructor() {
    this.basicURL = "/Estadistica";
  }

    async getEstadisticas() {
        const endpoint = `${this.basicURL}/GetEstadisticas`;
        try {
            const response = await apiClient.get(endpoint);
            return response.data;
        } catch (error: unknown) {
            if (isAxiosError(error)) {
                return error.response;
            }
            return "Error al traer la lista de estadísticas";
        }
    }
  }

export default EstadisticasService;